import { render, staticRenderFns } from "./UnBindPage.vue?vue&type=template&id=839d429c&scoped=true&"
import script from "./UnBindPage.vue?vue&type=script&lang=js&"
export * from "./UnBindPage.vue?vue&type=script&lang=js&"
import style0 from "./UnBindPage.vue?vue&type=style&index=0&id=839d429c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839d429c",
  null
  
)

export default component.exports